import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import withStyles from 'react-jss';
import ComponentHeader from '../../ecap/ComponentHeader';
import BackArrow from '../../utility/BackArrow';
import {
  insertTenantTableData,
  uploadTenantPhotoToS3,
  insertTenantFeatures,
  insertFeaturesByName,
  insertCareerCategories,
  insertCareers,
  insertDegrees,
  insertHighSchools,
  insertGameImages,
  insertHighSchoolClasses,
  insertSkillsCourseRecommendations,
  updateTenantDegrees,
  checkJobStatus,
} from '../../../store/actions';
import ErrorMessage from '../../ErrorMessage';
import {
  labelAndFileSelector,
  checkboxAndLabel,
  checkJobStatusInterval,
  displayLoadingOrSuccess,
} from './modalUtil';

const fileCustom = {
  backgroundColor: (props) => ({
    '&::before': {
      backgroundColor: props.tenant?.primary || '#000000',
      content: `'Select'`,
      border: `1px solid $`,
    },
  }),
  button: (props) => ({
    backgroundColor: props.tenant?.primary,
    color: 'white',
    border: `1px solid ${props.tenant?.primary || '#000000'}`,

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.tenant?.primary || '#000000'}`,
      color: props.tenant?.primary,
    },
    '&:disabled': {
      color: 'black',
      border: 'none',
      backgroundColor: '#e5e5e5',
      padding: ' 0 34px',
      cursor: 'not-allowed',
    },
  }),
};
export class UpdateDegreesModal extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      acknowledgement: false,
      degrees: null,
      degreeTranslations: null,
      loading: false,
      error: '',
      success: false,
    };
  }

  disabledButtonContainerStyle = {
    backgroundColor: 'white',
    border: `1px solid #E0E0E0`,
    cursor: 'not-allowed',
  };

  isButtonDisabled = () => {
    const { acknowledgement, degrees, degreeTranslations } = this.state;
    if (this.props.tenant.name === 'ASU') {
      return !acknowledgement || !degreeTranslations;
    }
    return !degrees;
  };

  handleAcknowledgement = () => {
    this.setState((prevState) => ({
      acknowledgement: !prevState.acknowledgement,
    }));
  };

  handleUpdate = async () => {
    const { degrees, degreeTranslations } = this.state;
    let error, success;
    const jobIdentifier = `${this.state.name}_${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, '')}`;
    this.setState({
      loading: true,
      error: '',
      success: false,
    });

    const response = await this.props.updateTenantDegrees(
      this.props.tenant.id,
      jobIdentifier,
      this.props.tenant.name === 'ASU' ? null : degrees,
      this.props.tenant.name === 'ASU' ? degreeTranslations : null
    );

    if (
      !!response?.status &&
      (response.status === 500 || response.status === 401)
    ) {
      error = response.data;
    }
    const jobStatus = await checkJobStatusInterval(
      jobIdentifier,
      this.props.checkJobStatus
    );
    if (jobStatus.status !== 'SUCCESS') {
      error = `Something went wrong with the update. Status: '${jobStatus.error_message}'`;
    } else {
      success = true;
    }
    this.setState({
      loading: false,
      error,
      success,
    });
  };

  peoplesoftButton = () => {
    return (
      <div className="tenant-modal__degrees-buttons-container">
        {labelAndFileSelector(
          'Degrees Translations For PeopleSoft Degrees',
          'Data required for complete tenant updates. Requires CSV file.',
          'degreeTranslations',
          this.setFile,
          this.state.degreeTranslations,
          this.props.classes.backgroundColor
        )}
        {checkboxAndLabel(
          'By clicking this box I acknowledge that degrees will be pulled automatically from PeopleSoft.',
          this.state.acknowledgement,
          this.handleAcknowledgement
        )}
        <button
          className={classNames(
            'button--primary',
            'tenant-modal__save-button',
            'tenant-modal__margin-bottom',
            this.props.classes.button
          )}
          disabled={this.isButtonDisabled()}
          type="button"
          onClick={async () => {
            this.handleUpdate();
          }}
        >
          Sync with PeopleSoft
        </button>
        <button
          className={classNames(
            'button--primary',
            'tenant-modal__add-dash-button',
            'tenant-modal__margin-bottom',
            this.props.classes.button
          )}
          type="button"
          onClick={async () => {
            this.props.closeTenantModal();
          }}
        >
          Close
        </button>
      </div>
    );
  };

  setFile = (e) => {
    this.setState({
      [e.target.id]: e.target.files[0],
    });
  };

  saveButton = () => {
    return (
      <div className="tenant-modal__save-button-container">
        <button
          className={classNames(
            'button--primary',
            'tenant-modal__save-button',
            this.props.classes.button
          )}
          style={
            this.isButtonDisabled() ? this.disabledButtonContainerStyle : null
          }
          disabled={this.isButtonDisabled()}
          type="button"
          onClick={async () => {
            this.handleUpdate();
          }}
        >
          Save
        </button>
      </div>
    );
  };

  render() {
    const { tenant } = this.props;
    let componentHeaderTenant = tenant;
    if (tenant === undefined) {
      componentHeaderTenant = {
        primary: this.state.primary,
        secondary: this.state.secondary,
      };
    }
    return (
      <>
        <div
          className="tenant-modal__navigate-back"
          tabIndex={0}
          role="button"
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key))
              this.props.openTenantModal('Edit', this.props.tenant.id);
          }}
          onClick={() => {
            this.props.openTenantModal('Edit', this.props.tenant.id);
          }}
        >
          <BackArrow
            size="35px"
            color={this.props.tenant.primary}
            title="Left arrow"
          />
          <p
            className="tenant-modal__back-text"
            style={{ color: this.props.tenant.primary }}
          >
            Back
          </p>
        </div>
        {this.state.loading || this.state.success ? (
          displayLoadingOrSuccess(
            this.props.tenant.name,
            this.state.loading,
            this.state.success,
            'degrees'
          )
        ) : (
          <>
            <ComponentHeader
              headerText={`Update Degrees for ${this.props.tenant.name}`}
              tenant={componentHeaderTenant}
              marginTop="0px"
            />
            <div className="tenant-modal__edit-careers-container">
              {this.props.tenant.name === 'ASU' && this.peoplesoftButton()}
              {this.props.tenant.name !== 'ASU' && (
                <>
                  {labelAndFileSelector(
                    'Degrees with Career Pairings',
                    'Data required for complete tenant updates. Requires CSV file.',
                    'degrees',
                    this.setFile,
                    this.state.degrees,
                    this.props.classes.backgroundColor
                  )}
                  {!!this.state.error && (
                    <ErrorMessage error={this.state.error} />
                  )}
                  {this.saveButton()}
                </>
              )}
            </div>
          </>
        )}
      </>
    );
  }
}

export default connect(null, {
  uploadTenantPhotoToS3,
  insertTenantTableData,
  insertTenantFeatures,
  insertFeaturesByName,
  insertCareerCategories,
  insertCareers,
  insertDegrees,
  insertHighSchools,
  insertGameImages,
  insertHighSchoolClasses,
  insertSkillsCourseRecommendations,
  updateTenantDegrees,
  checkJobStatus,
})(withStyles(fileCustom)(UpdateDegreesModal));
